import React from 'react'

export default function QuestionnaireBanner() {
  return (
    <div className="questionnaire__banner">
      <div className="questionnaire__banner-strip">
        <div className="questionnaire__banner-strip--start">
          <p>
            Takes <span>under a minute</span>
          </p>
        </div>
        <div className="questionnaire__banner-strip--end">
          <p>
            🎉 <span>Looks like you could have a claim</span> 🎉
          </p>
          <p>
            Fill in the form to find out how much you
            <br /> could be owed
          </p>
        </div>
      </div>
    </div>
  )
}
